import { ThumbUpOutlined as ThumbUpOutlineIcon } from '@mui/icons-material';

const ThumbUpOutline = (): JSX.Element => <ThumbUpOutlineIcon fontSize="inherit" />;

export default ThumbUpOutline;
